"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Title = _interopRequireDefault(require("../Title"));

var _SectionTile = _interopRequireDefault(require("../SectionTile"));

var _sectionTileGroup = _interopRequireDefault(require("./sectionTileGroup.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var SectionTileGroupWrapper = _styledComponents.default.div.withConfig({
  displayName: "SectionTileGroup__SectionTileGroupWrapper",
  componentId: "sc-192fxoa-0"
})([""]);

var SectionTileWrapper = _styledComponents.default.div.withConfig({
  displayName: "SectionTileGroup__SectionTileWrapper",
  componentId: "sc-192fxoa-1"
})(["display:grid;display:-ms-grid;", " -ms-grid-columns:(calc(100% / 12))[12];grid-gap:", ";"], function (_ref) {
  var numOfCol = _ref.numOfCol;
  return (0, _styledComponents.css)(["grid-template-columns:repeat(", ",1fr);grid-auto-columns:calc(100% / (", "));"], numOfCol, numOfCol);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.standard;
});

var SectionTileGroup = function SectionTileGroup(props) {
  var title = props.title,
      titleColor = props.titleColor,
      titleAlign = props.titleAlign,
      data = props.data,
      defaultSelectedData = props.defaultSelectedData,
      onClick = props.onClick,
      activeTitleColor = props.activeTitleColor,
      activeBackGroundColor = props.activeBackGroundColor,
      titleType = props.titleType,
      numOfCol = props.numOfCol,
      enableHover = props.enableHover,
      minHeight = props.minHeight,
      alignCenter = props.alignCenter,
      defaultBorderColor = props.defaultBorderColor,
      isMultipleChoiceAllowed = props.isMultipleChoiceAllowed,
      multipleSelectedData = props.multipleSelectedData,
      theme = props.theme,
      accessible = props.accessible,
      customProperties = props.customProperties;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var _useState = (0, _react.useState)(defaultSelectedData),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      selectedData = _useState2[0],
      setSelectedData = _useState2[1];

  var _useState3 = (0, _react.useState)(multipleSelectedData),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      subtags = _useState4[0],
      setSubtags = _useState4[1];

  var onClickHandler = function onClickHandler(val, isActive) {
    setSelectedData(val);

    if (!onClick || typeof val === 'undefined') {
      return;
    }

    if (isMultipleChoiceAllowed) {
      var temp = [].concat((0, _toConsumableArray2.default)(subtags), [val]);

      if (!isActive) {
        temp = temp.filter(function (el) {
          return el !== val;
        });
      }

      setSubtags(temp);
      onClick(temp);
    } else {
      onClick(val);
    }
  };

  (0, _react.useEffect)(function () {
    setSelectedData(defaultSelectedData);
  }, [defaultSelectedData]);

  var activeSectionTileHandler = function activeSectionTileHandler(d) {
    if (isMultipleChoiceAllowed) {
      return multipleSelectedData ? multipleSelectedData.includes(d.value) : false;
    }

    return d.value === selectedData;
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(SectionTileGroupWrapper, (0, _extends2.default)({
      role: "list"
    }, customProperties), title && /*#__PURE__*/_react.default.createElement(_Title.default, {
      color: titleColor,
      textAlign: titleAlign,
      accessible: accessible,
      theme: theme,
      type: "h3",
      marginBottom: "standard"
    }, title), /*#__PURE__*/_react.default.createElement(SectionTileWrapper, {
      numOfCol: numOfCol,
      id: "section-tile-wrapper"
    }, // eslint-disable-next-line react/prop-types
    data.map(function (d, idx) {
      return /*#__PURE__*/_react.default.createElement(_SectionTile.default, (0, _extends2.default)({
        key: d.value,
        active: activeSectionTileHandler(d),
        theme: theme,
        accessible: accessible,
        index: idx,
        onClick: onClickHandler,
        customProperties: {
          role: 'listitem'
        },
        alignCenter: alignCenter,
        enableHover: enableHover,
        titleType: titleType,
        minHeight: minHeight,
        activeBackGroundColor: activeBackGroundColor,
        activeTitleColor: activeTitleColor,
        defaultBorderColor: defaultBorderColor
      }, d, {
        value: d.id || d.value
      }));
    })));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

SectionTileGroup.propTypes = _sectionTileGroup.default.PropTypes;
SectionTileGroup.defaultProps = _sectionTileGroup.default.DefaultProps;
var _default = SectionTileGroup;
exports.default = _default;